<template>
  <div class="vuestic-modal">
    <transition name="modal" :duration="duration">
      <div v-show="show" class="modal-container">
        <div class="modal" @click.self="clickMask">
          <div class="modal-dialog" :class="modalClass">
            <div class="modal-content">
              <!--Header-->
              <div class="modal-header">
                <slot name="header">
                  <div class="modal-title">
                    <slot name="title"></slot>
                  </div>

                  <i
                    class="ion ion-md-close close-modal"
                    v-if="closeIconShown"
                    @click.prevent="cancel"
                  />
                </slot>
              </div>
              <!--Container-->
              <div class="modal-body">
                <slot></slot>
                <div class="tip-select">
                  <input
                    type="text"
                    class="tip-select__input"
                    autocomplete="off"
                    placeholder="Tip uzorka"
                    v-model="searchText"
                    @focus="openDropdown"
                    @input="onInput"
                    @blur="closeDropdown"
                    @keydown.esc="closeDropdown"
                  />
                  <div v-show="dropdownOpen" class="tip-select__menu">
                    <div
                      v-for="(option, index) in filteredOptions"
                      :key="index"
                      class="tip-select__item"
                      @mousedown.prevent="selectOption(option)"
                    >{{ option }}</div>
                    <div v-if="!filteredOptions.length" class="tip-select__item tip-select__item--empty">{{ "Nema rezultata" }}</div>
                  </div>
                </div>
              </div>
              <!--Footer-->
              <div class="modal-footer">
                <slot name="footer">
                  <button
                    type="button"
                    v-if="!noButtons"
                    :class="cancelClass"
                    @click="cancel"
                    :disabled="cancelDisabled"
                  >{{ cancelText }}</button>
                  <button
                    type="button"
                    v-if="!noButtons"
                    :class="okClass"
                    @click="ok"
                    :disabled="okDisabled || !selectedTip"
                  >{{ okText }}</button>
                </slot>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-backdrop"></div>
      </div>
    </transition>
  </div>
</template>

<script>
import { bus } from "../../main";

export default {
  name: "modal-samples-entry-tip",
  props: {
    transition: {
      type: String,
      default: "modal"
    },
    small: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    },
    force: {
      type: Boolean,
      default: true
    },
    okText: {
      type: String,
      default: "SAČUVAJ"
    },
    cancelText: {
      type: String,
      default: "ODUSTANI"
    },
    okClass: {
      type: String,
      default: "btn btn-primary btn-sm"
    },
    cancelClass: {
      type: String,
      default: "btn btn-warning btn-sm"
    },
    closeIconShown: {
      type: Boolean,
      default: false
    },
    okDisabled: {
      type: Boolean,
      default: false
    },
    cancelDisabled: {
      type: Boolean,
      default: false
    },
    noButtons: {
      type: Boolean,
      default: false
    },
    sample: {
      type: String,
      default: ""
    },
    trenutniTip: {
      type: String,
      default: ""
    },
    options: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      show: false,
      duration: 500,
      selectedTip: "",
      searchText: "",
      dropdownOpen: false,
      uzorak: ""
    };
  },
  computed: {
    modalClass() {
      return {
        "modal-lg": this.large,
        "modal-sm": this.small
      };
    },
    filteredOptions() {
      var q = (this.searchText || "").toLowerCase();
      if (!q) {
        return this.options;
      }
      return this.options.filter((option) =>
        option.toLowerCase().includes(q)
      );
    }
  },
  created() {
    if (this.show) {
      document.body.className += " modal-open";
    }
  },
  beforeDestroy() {
    document.body.className = document.body.className.replace(
      /\s?modal-open/,
      ""
    );
  },
  watch: {
    trenutniTip: function(newVal, oldVal) {
      this.selectedTip = newVal;
      this.searchText = newVal;
    },

    sample: function(newVal, oldVal) {
      this.uzorak = newVal;
    },

    show(value) {
      if (value) {
        document.body.className += " modal-open";
      } else {
        window.setTimeout(() => {
          document.body.className = document.body.className.replace(
            /\s?modal-open/,
            ""
          );
        }, this.duration);
      }
    }
  },
  methods: {
    listenKeyUp(event) {
      if (event.key === "Escape") {
        this.cancel();
      }
    },
    openDropdown() {
      this.dropdownOpen = true;
    },
    closeDropdown() {
      this.dropdownOpen = false;
      this.searchText = this.selectedTip;
    },
    onInput() {
      this.selectedTip = "";
      this.dropdownOpen = true;
    },
    selectOption(option) {
      this.selectedTip = option;
      this.searchText = option;
      this.dropdownOpen = false;
    },
    ok() {
      this.$emit("ok");
      bus.$emit("setSampleTip", this.uzorak, this.selectedTip);
      this.show = false;
      this.dropdownOpen = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    },
    cancel() {
      this.$emit("cancel");
      this.show = false;
      this.dropdownOpen = false;
      this.searchText = this.selectedTip;
      window.removeEventListener("keyup", this.listenKeyUp);
    },
    clickMask() {
      if (!this.force) {
        this.cancel();
      }
    },
    open() {
      this.show = true;
      window.addEventListener("keyup", this.listenKeyUp);
    },
    close() {
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    }
  }
};
</script>

<style lang="scss">
@import "../../sass/_variables.scss";

.vuestic-modal {
  height: 0;
  width: 0;

  .modal {
    display: block;
  }

  .modal-dialog,
  .modal-backdrop {
    transition: all 0.5s ease;
  }

  .modal-enter .modal-dialog,
  .modal-leave-active .modal-dialog {
    opacity: 0;
    transform: translateY(-30%);
  }

  .modal-enter .modal-backdrop,
  .modal-leave-active .modal-backdrop {
    opacity: 0;
  }

  .modal-backdrop {
    opacity: 0.5;
  }

  .modal-header {
    height: $modal-header-height;
    padding: $modal-header-padding-y $modal-header-padding-x;
    border-bottom: $modal-header-border;
    font-size: $font-size-larger;
    display: flex;
    align-items: center;
  }

  .close-modal {
    margin-left: 1rem;
    font-size: $font-size-large;
    line-height: $font-size-large;
    cursor: pointer;
  }

  .modal-content {
    border-radius: $modal-content-border-radius;
  }

  .modal-footer {
    justify-content: center;
    padding: 0 $modal-inner-padding;
    padding-bottom: calc(
      #{$modal-inner-padding} - #{$modal-footer-btns-padding-bottom}
    );
    flex-wrap: wrap;
    .btn {
      margin: 0 $modal-footer-btns-margin-x $modal-footer-btns-padding-bottom
        $modal-footer-btns-margin-x;
    }
  }

  .tip-select {
    position: relative;
    margin-bottom: 1rem;

    &__input {
      width: 100%;
      height: 2.5rem;
      padding: 0 0.75rem;
      border: 1px solid $input-border-color;
      border-radius: 4px;
      font-size: $font-size-base;
      color: $body-color;

      &:focus {
        outline: none;
        border-color: $brand-primary;
      }
    }

    &__menu {
      position: absolute;
      top: calc(100% + 2px);
      left: 0;
      right: 0;
      max-height: 220px;
      overflow-y: auto;
      background: $white;
      border: 1px solid $lighter-gray;
      border-radius: 4px;
      box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
      z-index: 1100;
    }

    &__item {
      padding: 0.5rem 0.75rem;
      cursor: pointer;
      color: $body-color;

      &:hover {
        background: $light-gray2;
      }

      &--empty {
        cursor: default;
        color: $gray;

        &:hover {
          background: transparent;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/02_samples/TipUzorka.vue